const BASE = "https://api.dicebear.com/10.x/gaze";

/**
 * Strip pool-distribution prefixes (`emp_123`, `employer_45`) so the seed matches
 * workforce employee/employer entity ids used elsewhere in Emp apps.
 */
export function normalizeWorkforceSeed(seed) {
  let s = String(seed ?? "").trim();
  if (!s) return "";
  const lower = s.toLowerCase();
  if (lower.startsWith("emp_")) s = s.slice(4);
  else if (lower.startsWith("employer_")) s = s.slice(9);
  return s.trim();
}

/** Animated SVG (no background, no border radius). */
export function dicebearAvatarUrl(seed) {
  const s = normalizeWorkforceSeed(seed);
  if (!s) return "";
  return `${BASE}/svg?seed=${encodeURIComponent(s)}&animationVariant=medium`;
}

/** Prefer photo when non-blank; Dicebear URLs re-resolved with normalized seed. */
export function resolvedAvatarUrl(photoUrl, seed, seedFallback) {
  const photo = String(photoUrl || "").trim();
  if (photo && !isDicebearUrl(photo)) return photo;
  const fromApi = seedFromDicebearUrl(photo);
  const resolved =
    fromApi ||
    normalizeWorkforceSeed(seed) ||
    normalizeWorkforceSeed(seedFallback);
  if (!resolved) return null;
  return dicebearAvatarUrl(resolved);
}

export function isDicebearUrl(url) {
  return Boolean(String(url || "").trim().startsWith(BASE));
}

function seedFromDicebearUrl(url) {
  if (!isDicebearUrl(url)) return "";
  try {
    const q = String(url).split("?")[1] || "";
    const params = new URLSearchParams(q);
    return normalizeWorkforceSeed(params.get("seed"));
  } catch {
    return "";
  }
}
